import {caseAnomaliesService} from '../../application'

export async function caseAnomaliesReCalculateCaseAnomalies({state, commit, dispatch}, {caseId}) {
  return caseAnomaliesService.reCalculateCaseAnomalies({caseId})
}

export async function caseAnomaliesReCalculateAllCasesAnomalies({state, commit, dispatch}) {
  return caseAnomaliesService.reCalculateAllCasesAnomalies()
}



// WEBPACK FOOTER //
// ./src/store/actions/case-anomalies.js